<template>
    <vs-row vs-w="12">
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Task</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(101)" v-model="permissionsArray" :vs-value=101>Add task</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(102)" v-model="permissionsArray" :vs-value="102">Take task</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(103)" v-model="permissionsArray" :vs-value="103">Give task</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(104)" v-model="permissionsArray" :vs-value="104">Edit task</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(105)" v-model="permissionsArray" :vs-value="105">Delete task</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(106)" v-model="permissionsArray" :vs-value="106">Assign user to task</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(107)" v-model="permissionsArray" :vs-value="107">Edit task time</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(108)" v-model="permissionsArray" :vs-value="108">Steal task</vs-checkbox>
        </vs-col>
        <vs-col vs-w="8" vs-sm="12" class="mt-6">
            <h5 class="p-3">Project</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(201)" v-model="permissionsArray" :vs-value="201">Add project</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(212)" v-model="permissionsArray" :vs-value="212">Add to others</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(202)" v-model="permissionsArray" :vs-value="202">Edit project</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(203)" v-model="permissionsArray" :vs-value="203">Delete project</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(204)" v-model="permissionsArray" :vs-value="204">View project template</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(205)" v-model="permissionsArray" :vs-value="205">Add project template</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(206)" v-model="permissionsArray" :vs-value="206">Edit project template</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(207)" v-model="permissionsArray" :vs-value="207">Delete project template</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(208)" v-model="permissionsArray" :vs-value="208">View project offers</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(209)" v-model="permissionsArray" :vs-value="209">Add project offer</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(210)" v-model="permissionsArray" :vs-value="210">Edit project offer</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(211)" v-model="permissionsArray" :vs-value="211">Delete project offer</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(213)" v-model="permissionsArray" :vs-value="213">Finish project with handover</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(214)" v-model="permissionsArray" :vs-value="214">Finish project without handover</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(215)" v-model="permissionsArray" :vs-value="215">Finish project with handover others</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(216)" v-model="permissionsArray" :vs-value="216">Finish project without handover others</vs-checkbox>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Client</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(301)" v-model="permissionsArray" :vs-value="301">View client details</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(306)" v-model="permissionsArray" :vs-value="306">Edit details</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(302)" v-model="permissionsArray" :vs-value="302">Add client</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(303)" v-model="permissionsArray" :vs-value="303">Edit client</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(304)" v-model="permissionsArray" :vs-value="304">Disable client</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(305)" v-model="permissionsArray" :vs-value="305">Delete client</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(307)" v-model="permissionsArray" :vs-value="307">Edit client contacts</vs-checkbox>

        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">User</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(401)" v-model="permissionsArray" :vs-value="401">View user details</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(402)" v-model="permissionsArray" :vs-value="402">Add user</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(403)" v-model="permissionsArray" :vs-value="403">Edit user</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(404)" v-model="permissionsArray" :vs-value="404">Delete user</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(405)" v-model="permissionsArray" :vs-value="405">Edit user hours</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(406)" v-model="permissionsArray" :vs-value="406">Edit user absence</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(407)" v-model="permissionsArray" :vs-value="407">Edit user vacation allowance</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(408)" v-model="permissionsArray" :vs-value="408">Add user absences</vs-checkbox>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Roles</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(701)" v-model="permissionsArray" :vs-value="701">View roles</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(702)" v-model="permissionsArray" :vs-value="702">Edit roles</vs-checkbox>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Work types</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(501)" v-model="permissionsArray" :vs-value="501">Edit work types</vs-checkbox>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">User types</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(601)" v-model="permissionsArray" :vs-value="601">Edit user types</vs-checkbox>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Vehicles</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(801)" v-model="permissionsArray" :vs-value="801">Edit vehicles</vs-checkbox>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Transport types</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(901)" v-model="permissionsArray" :vs-value="901">Edit transport types</vs-checkbox>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Settings</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1001)" v-model="permissionsArray" :vs-value="1001">Edit company settings</vs-checkbox>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Invoicing</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1101)" v-model="permissionsArray" :vs-value="1101">View invoicing</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1102)" v-model="permissionsArray" :vs-value="1102">Edit invoicing</vs-checkbox>
        </vs-col>

        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Travel orders</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1201)" v-model="permissionsArray" :vs-value="1201">View travel orders</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1202)" v-model="permissionsArray" :vs-value="1202">Edit travel orders</vs-checkbox>
        </vs-col>

        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Company</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1302)" v-model="permissionsArray" :vs-value="1302">Show company tab</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1301)" v-model="permissionsArray" :vs-value="1301">View open tasks</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1303)" v-model="permissionsArray" :vs-value="1303">View client time overview</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1304)" v-model="permissionsArray" :vs-value="1304">View time analytics</vs-checkbox>
        </vs-col>

        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Calendar</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1401)" v-model="permissionsArray" :vs-value="1401">View absence calendar</vs-checkbox>
        </vs-col>

        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Tags</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1501)" v-model="permissionsArray" :vs-value="1501">Edit tags</vs-checkbox>
        </vs-col>

        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Artificial transports</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1601)" v-model="permissionsArray" :vs-value="1601">Use Artificial transports</vs-checkbox>
        </vs-col>

        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Business trips</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1701)" v-model="permissionsArray" :vs-value="1701">Edit business trips</vs-checkbox>
        </vs-col>

        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">On call management</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1801)" v-model="permissionsArray" :vs-value="1801">Edit on call users</vs-checkbox>
        </vs-col>

        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Offers</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1901)" v-model="permissionsArray" :vs-value="1901">View offers</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1902)" v-model="permissionsArray" :vs-value="1902">Add offer</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(1903)" v-model="permissionsArray" :vs-value="1903">Make commercial offers</vs-checkbox>
        </vs-col>

        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Meetings</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2001)" v-model="permissionsArray" :vs-value="2001">View meetings</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2002)" v-model="permissionsArray" :vs-value="2002">Add meeting</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2003)" v-model="permissionsArray" :vs-value="2003">Meeting admin access</vs-checkbox>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Wiki</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2101)" v-model="permissionsArray" :vs-value="2101">Access Wiki</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2102)" v-model="permissionsArray" :vs-value="2102">Access Commercial Wiki</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2103)" v-model="permissionsArray" :vs-value="2103">Access Board Wiki</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2104)" v-model="permissionsArray" :vs-value="2104">Access ISO Wiki</vs-checkbox>
        </vs-col>

        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Registration terminal</h5>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2201)" v-model="permissionsArray" :vs-value="2201">View terminals</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2202)" v-model="permissionsArray" :vs-value="2202">Add terminal</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2203)" v-model="permissionsArray" :vs-value="2203">Edit terminal</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2204)" v-model="permissionsArray" :vs-value="2204">Remove terminal</vs-checkbox>
            <vs-checkbox class="mt-3" :disabled="disabledPermissions.includes(2205)" v-model="permissionsArray" :vs-value="2205">Get terminal link</vs-checkbox>
        </vs-col>
    </vs-row>
</template>
<script>
    export default {
        props: {
            permissions: {
                type: Array,
                required: true
            },
            disabledPermissions: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                permissionsArray: []
            }
        },
        computed:{
            permissionArrayNoDisabled: function () {
                let list = [];
                for(let x = 0; x < this.permissionsArray.length; x++){
                    if(!this.disabledPermissions.includes(this.permissionsArray[x])){
                        list.push(this.permissionsArray[x]);
                    }
                }

                return list;
            }
        },
        watch: {
            permissions: function () {
                this.permissionsArray = JSON.parse(JSON.stringify(this.permissions));
                for(let x = 0; x < this.disabledPermissions.length; x++){
                    this.permissionsArray.push(this.disabledPermissions[x])
                }
            },
            disabledPermissions: function () {
                this.permissionsArray = JSON.parse(JSON.stringify(this.permissions));
                for(let x = 0; x < this.disabledPermissions.length; x++){
                    this.permissionsArray.push(this.disabledPermissions[x])
                }
            }
        },
        created() {
            this.permissionsArray = JSON.parse(JSON.stringify(this.permissions));
            for(let x = 0; x < this.disabledPermissions.length; x++){
                this.permissionsArray.push(this.disabledPermissions[x])
            }

        }
    }
</script>
